<template>
  <div>
    <div class="bg-vlight-paper shadow overflow-hidden sm:rounded-md mt-6">
      <div class="border-b border-gray-200 px-4 py-5 sm:px-6">
        <h3
          class="text-2xl leading-8 font-bebas tracking-wide text-darkpurple font-extrabold  sm:text-3xl sm:leading-9"
        >
          Thank you for your order
        </h3>
      </div>

      <div class="tracking-wide px-4 py-5 sm:p-6 text-lg leading-6 font-medium text-gray-900">
        <p>
          <span class="text-darkpurple font-extrabold ">Order Reference:</span>
          {{ reference }}
        </p>
        <p><span class="text-darkpurple font-extrabold">Product:</span> {{ product }}</p>
        <p class="mt-5">
          You will shortly receive an email from FastSpring, our authorised
          Payment Provider, with receipt of your payment. Once your order has
          completed you will receive a further email containing the link to
          download the bundle
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="js">

export default {
    name: "PurchaseConfirmation",
    components: {},
    data() {
        return {
            reference: "no reference",
          product: "Vectric User Group Bundle"
        };
    },
    created() {
        const url = new URL(window.location.href);
        this.reference = url.searchParams.get("reference");
    },
    mounted() {
    },

    methods: {

    },

};
</script>
